import React, { useState, createContext } from "react";
import { ThemeProvider } from "styled-components";
import Navbar from "./components/Navbar/Navbar";
import Hero from "./components/HeroSection/hero";
import GlobalStyles from "./Global";
import { Projects } from "./components/Projects/Projects";
import Dropdown from "./components/Menu/Menu";
import { Footer } from "./components/Footer/Footer";
import Skills from "./components/Skills/Skills";
import ViewAllProjects from "./components/ViewAllProjects/ViewAllProjects";

// import {BrowserRouter as Router, Routes, Route} from "react-router-dom"



const theme = {
  colors: {
    primary: "#725cff",
    secondary: "#271b71",
    secondarytextcolor: "#fff",
  },
  breakpoints: {
    mobile: "600px",
    tablet: "891px",
    desktop: "1024px",
    largedesktop: "1300px",
  },
};

export const AppContext = createContext({});

const App = () => {
  const [active, setActive] = useState(false);

  function toggleMenu() {
    setActive(() => !active);
    console.log("i was clicked");
  }

  return (
    <ThemeProvider theme={theme}>
      <AppContext.Provider value={toggleMenu}>
        <GlobalStyles />
        {active && <Dropdown/>}
        <Navbar />
        <Hero />
        <Skills />
        <Projects />
        <ViewAllProjects/>
        <Footer />
      </AppContext.Provider>
    </ThemeProvider>
  );
};

export default App;

// if we want to make a darkmode that means everystyle , i.e color, will be originating from a theme.light and it will have a theme.dark value
